import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { Icon } from "signoxe/components/widgets";
import { AssetPropType } from "signoxe/constants/propTypes";
import "./styles.scss";

import calendarImg from "signoxe/images/calendar.jpg";
import aqiImg from "signoxe/images/aqi.jpg";
import fidsImg from "signoxe/images/FIDS.jpg";
import urlImg from "signoxe/images/url.jpg";
import htmlImg from "signoxe/images/html.jpg";
import pdfImg from "signoxe/images/PDF.jpg";
import audioImg from "signoxe/images/music.png";


const AssetPreview = ({ asset, onClick, size }) => {
  const { type, thumbnail } = asset;
  const assetType = (asset.type || "").toLowerCase();
  let icon;

  if (type === "IMAGE" || type === "VIDEO" || type === "WEB") {
    icon = <img src={thumbnail} />;
  } else if (type === "FEED") {
    icon = <Icon name="feed" size={80} />;
  } else if (type === "CALENDAR") {
    icon = <Icon name="calendar" size={80} />;
  } else if (type === "WEB" || type === "ZIP") {
    icon = <img src={htmlImg} />;
  } else if (type === "AQI" || type === "AQI_VEDA") {
    icon = <img src={aqiImg} />;
  } else if (type === "URL") {
    icon = <img src={urlImg} />;
  } else if (type === "FIDS") {
    icon = <img src={fidsImg} />;
  } else if (type === "PDF") {
    icon = <img src={pdfImg} />;
  } else if (type === "AUDIO") {
    icon = <img src={audioImg} />;
  }

  const sizeStyle = size ? { maxWidth: size, maxHeight: size } : null;

  //console.log('Type was ', type)

  return (
    <div
      className={classNames("asset-icon", assetType, { linked: onClick })}
      style={sizeStyle}
      onClick={onClick}
    >
      {icon}
    </div>
  );
};

AssetPreview.propTypes = {
  asset: AssetPropType.isRequired,
  size: PropTypes.string,
  onClick: PropTypes.func,
};

export default AssetPreview;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/AssetPreview/index.js